import { useEnterpriseBusinessSegmentsQuery, getQueryBusinessSegmentsById } from '@mews-commander/core/entities';

export const BusinessSegmentName = ({ businessSegmentId }: { businessSegmentId: string }) => {
    const { data: businessSegmentsById } = useEnterpriseBusinessSegmentsQuery(getQueryBusinessSegmentsById);
    const businessSegment = businessSegmentsById?.[businessSegmentId];
    return businessSegment ? <>{businessSegment.name}</> : null;
};
